import React from 'react';
import InfoCards from '../components/Resources/InfoCards';
import EventHighlights from '../components/Resources/EventHighlights';



const ResourceEvent = () => {
  return (
    <div>
      <EventHighlights/>

      <InfoCards/>



    </div>
  );
};

export default ResourceEvent;
